import React from 'react';

export interface FacebookWidgetProps {
  linkText: string;
  href: string;
}

/* *********************** *
 *    FacebookWidget    *
 * *********************** */

export const FacebookWidget = ({ linkText, href }: FacebookWidgetProps) => {
  return (
    <div
      className="fb-page"
      data-href={href}
      // data-tabs="timeline"
      data-show-posts="true"
      data-width="500"
      data-height="750"
      data-small-header="true"
      data-adapt-container-width="true"
      data-hide-cover="true"
      data-show-facepile="false"
    >
      <blockquote cite={href} className="fb-xfbml-parse-ignore">
        <a href={href}>{linkText}</a>
      </blockquote>
    </div>
  );
};
